import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject, Observable } from 'rxjs';

import { LoadQuote } from '@ph-shopping/model/cart';

@Injectable({
  providedIn: 'root',
})
export class CartStoreRequestsDispatcher {
  //had to use Observables here because signals/signalStore implementation is buggy and triggers this signal infinitely
  private readonly _resetCartTracker$ = new BehaviorSubject<number>(0);
  readonly resetCartDispatched$: Observable<number> = this._resetCartTracker$.asObservable();

  private readonly _loadQuoteSuccessTracker$ = new Subject<LoadQuote>();
  readonly loadQuoteSuccessDispatched$: Observable<LoadQuote> = this._loadQuoteSuccessTracker$.asObservable();

  dispatchResetCart(): void {
    this._resetCartTracker$.next(this._resetCartTracker$.value + 1);
  }

  dispatchLoadQuoteSuccess(quote: LoadQuote): void {
    this._loadQuoteSuccessTracker$.next(quote);
  }
}
